import { useFormik } from 'formik';
import { initialValues, validationSchema } from './formData';
import { Tender } from '../../../../../shared/types/tender';
import { useEffect, useState } from 'react';
import { ISelect, ParamEnum } from '../../../../../shared/types/shared';
import {
    asyncGetParamByCode,
    asyncGetParams,
} from '../../../../../services/param.service';
import { asyncGetProjects } from '../../../../../services/projects.service';

const PREPLIEGOS_NAME = 'PREPLIEGOS';

export const useClientData = ({
    onChangeFormik,
    idTender,
}: {
    onChangeFormik?: any;
    idTender?: string;
}) => {
    const [processTypeOptions, setProcessTypeOptions] = useState<ISelect[]>([]);
    const [deliveryMethodOptions, setDeliveryMethodOptions] = useState<
        ISelect[]
    >([]);
    const [accountManagersOptions, setAccountManagersOptions] = useState<
        ISelect[]
    >([]);
    const [architectureManagersOptions, setArchitectureManagersOptions] =
        useState<ISelect[]>([]);
    const [statusProcessOptions, setStatusProcessOptions] = useState<ISelect[]>(
        []
    );
    const [otherAccountManagerParam, setOtherAccountManagerParam] =
        useState<ISelect>();
    const [otherArchitectureManagerParam, setOtherArchitectureManagerParam] =
        useState<ISelect>();
    const [projectOptions, setProjectOptions] = useState<ISelect[]>([]);

    const formik = useFormik<Tender>({
        initialValues,
        validationSchema: validationSchema(
            String(otherAccountManagerParam?.id || ''),
            String(otherArchitectureManagerParam?.id || '')
        ),
        onSubmit: () => undefined,
    });

    useEffect(() => {
        onChangeFormik?.(formik);
    }, [formik]);

    useEffect(() => {
        asyncGetParamByCode(`${ParamEnum.COMMERCIAL_MANAGER}_9`).then((item) =>
            setOtherAccountManagerParam(item)
        );
        asyncGetParamByCode(`${ParamEnum.ARCHITECTURE_MANAGER}_3`).then(
            (item) => setOtherArchitectureManagerParam(item)
        );
        const loadOptions = async () => {
            setProcessTypeOptions(await asyncGetParams(ParamEnum.PROCESS_TYPE));
            setDeliveryMethodOptions(
                await asyncGetParams(ParamEnum.DELIVERY_METHOD)
            );
            setAccountManagersOptions(
                await asyncGetParams(ParamEnum.COMMERCIAL_MANAGER)
            );
            setArchitectureManagersOptions(
                await asyncGetParams(ParamEnum.ARCHITECTURE_MANAGER)
            );
            const statusOpts = await asyncGetParams(ParamEnum.STATUS_PROCESS);
            setStatusProcessOptions(statusOpts);
            if (!idTender) {
                const prepliegos = statusOpts.find(
                    (o) => o.name?.toUpperCase() === PREPLIEGOS_NAME
                );
                if (prepliegos?.id != null) {
                    formik.setFieldValue(
                        'statusProcess',
                        String(prepliegos.id),
                        false
                    );
                }
            }

            const projectsResponse = await asyncGetProjects();

            setProjectOptions(
                projectsResponse.items
                    .filter((project) => project.id && project.name)
                    .map((project) => ({
                        id: project.id!,
                        name: project.name!,
                    }))
            );
        };
        loadOptions();
    }, [idTender]);

    return {
        formik,
        processTypeOptions,
        deliveryMethodOptions,
        accountManagersOptions,
        otherAccountManagerParam,
        architectureManagersOptions,
        otherArchitectureManagerParam,
        statusProcessOptions,
        projectOptions,
    };
};
